<template>
  <div class="tour">
    <v-tour
      :name="name"
      :steps="steps"
      :options="options"
      :callbacks="callbacks"
    />
  </div>
</template>

<script>
export default {
  name: 'Tour',
  props: {
    name: { type: String, required: true },
    steps: { type: Object, required: false, default: () => ({}) },
    options: {
      type: Object,
      required: false,
      default: () => ({
        highlight: true,
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Pular',
          buttonPrevious: 'Anterior',
          buttonNext: 'Próximo',
          buttonStop: 'Entendi!'
        }
      })
    },
    callbacks: { type: Object, required: false, default: () => ({}) }
  }
}
</script>

<style lang="scss">
@import 'assets/scss/variables';

.v-tour__target--highlighted {
  box-shadow: 0px 0px 0px 500vw rgba(40, 54, 81, 0.6);
  border-radius: 8px;
}

.v-tour {
  .v-step {
    background-color: $neutral500;
    border-radius: 8px;
    padding: 16px;
    max-width: 340px;

    .v-step__content {
      @include ParagraphSmall;
      color: $neutral100;
      text-align: initial;
    }

    .v-step__buttons {
      display: flex;
      justify-content: space-between;

      .v-step__button {
        @include ParagraphSmall;
        border: none;
        padding: 0;
        height: fit-content;

        &:hover {
          background-color: inherit;
        }

        &.v-step__button-skip {
          color: #ccd3e6;
          &:hover {
            color: #50596c;
          }
        }

        &.v-step__button-previous {
          height: 0;
          width: 0;
          font-size: 0;
          cursor: none;

          color: #50596c;
          &:hover {
            color: #ccd3e6;
          }
        }

        &.v-step__button-next,
        &.v-step__button-stop {
          font-weight: 700;
          color: $neutral100;

          &:hover {
            color: #ccd3e6;
          }
        }
      }
    }
  }
}
</style>
